import React from "react";

export default function Star(props) {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="#E2E8F0"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.93039 15.2025L13.7104 17.6025C14.1979 17.91 14.7979 17.4525 14.6554 16.89L13.5604 12.585C13.5308 12.4657 13.5355 12.3404 13.574 12.2237C13.6124 12.1069 13.6831 12.0034 13.7779 11.925L17.1679 9.09752C17.6104 8.73002 17.3854 7.98752 16.8079 7.95002L12.3829 7.66502C12.2622 7.65799 12.1461 7.61595 12.0488 7.54403C11.9516 7.4721 11.8774 7.37341 11.8354 7.26002L10.1854 3.10502C10.1417 2.98495 10.0621 2.88122 9.95749 2.80793C9.85283 2.73463 9.72816 2.69531 9.60039 2.69531C9.47262 2.69531 9.34794 2.73463 9.24329 2.80793C9.13863 2.88122 9.05906 2.98495 9.01539 3.10502L7.36539 7.26002C7.32333 7.37341 7.24916 7.4721 7.15193 7.54403C7.0547 7.61595 6.93862 7.65799 6.81789 7.66502L2.39289 7.95002C1.81539 7.98752 1.59039 8.73002 2.03289 9.09752L5.42289 11.925C5.51764 12.0034 5.58833 12.1069 5.62681 12.2237C5.66529 12.3404 5.67 12.4657 5.64039 12.585L4.62789 16.575C4.45539 17.25 5.17539 17.7975 5.75289 17.43L9.27039 15.2025C9.36903 15.1398 9.4835 15.1065 9.60039 15.1065C9.71728 15.1065 9.83175 15.1398 9.93039 15.2025Z"
        fill="inherit"
      />
    </svg>
  );
}
